import _ from 'underscore';
import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import View_Workspace_Member_Preview from 'view/workspace_member/preview';
import View_User_Invitation from 'view/user_invitation';

export default View.extend({
    tagName: 'section',

    member_type: 'all', // all | active | pending | deactivated
    search_value: '',

    views: {
        workspace_member_preview: {},
        invitation: {}
    },

    events: {
        'click .invite-member'         : 'onInviteMember',
        'click .search-launcher'       : 'onToggleMemberSearch',
        'input .search-launcher input' : 'onSearchMember',
        'click .tab-menu a'            : 'onTabChange',
        'click .account-upgrade'       : 'onAccountUpgrade'
    },

    dom_handlers: {
        onAccountUpgrade: function(e) {
            e.preventDefault();
            Modals.choosePlan();
        },

        onInviteMember: function() {
            Modals.inviteUser();
        },

        onToggleMemberSearch: function(e) {
            this.$el.find('.search-launcher').addClass('active');
        },

        onSearchMember: function(e) {
            this.search_value = $(e.currentTarget).val().toLowerCase();

            this.searchMembers();
        },

        onTabChange: function(e) {
            this.member_type = $(e.currentTarget).attr('href').replace('#', '');

            this.$el.find('.tab-menu > a').removeClass('active');
            $(e.currentTarget).addClass('active');

            window.location.hash = this.member_type;

            this.searchMembers();
        },

        onDocumentClick: function(e) {
            if (this.search_value) {
                return;
            }

            if ($(e.target).parents('.search-launcher').length ) {
                return;
            }

            this.$el.find('.search-launcher').removeClass('active');
        }
    },

    event_handlers: {
        onMemberRemove: function(model) {
            this.views.workspace_member_preview['_' + model.id].remove();
            delete this.views.workspace_member_preview['_' + model.id]
        },

        onDeleteUserInvitation: function(model) {
            this.views.invitation['_' + model.id].remove();
            delete this.views.invitation['_' + model.id];
        },

        onAddUserInvitation: function(model) {
            this.views.invitation['_' + model.id] = new View_User_Invitation({model: model});
            this.views.invitation['_' + model.id].render().$el.appendTo(this.$el.find('.region-members'));
        },
    },

    initialize: function() {
        Cache.workspace_member.each((model) => {
            this.views.workspace_member_preview['_' + model.id] = new View_Workspace_Member_Preview({model: model});
        });

        Cache.user_invitation.each((model) => {
            this.views.invitation['_' + model.id] = new View_User_Invitation({model: model});
        });

        this.listenTo(Cache.workspace_member, 'remove', this.event_handlers.onMemberRemove);

        this.listenTo(Cache.user_invitation, 'add',     this.event_handlers.onAddUserInvitation);
        this.listenTo(Cache.user_invitation, 'remove',  this.event_handlers.onDeleteUserInvitation);

        this.on('remove', () => {
            $(document).off('click.member_search');
        });

        var member_type = window.location.hash.replace('#', '');
        if (['all', 'active', 'pending', 'deactivated'].indexOf(member_type) !== -1) {
            this.member_type = member_type;
        }
    },

    onPageReady: function() {
        $(document).on('click.member_search', this.dom_handlers.onDocumentClick.bind(this));

        this.searchMembers();
    },

    searchMembers: function() {
        var show_count = 0;

        var matched_views = [];

        switch (this.member_type) {
            case 'active':
                _.each(this.views.invitation, (invitation_view) => {
                    invitation_view.$el.hide();
                });

                _.each(this.views.workspace_member_preview, (member_view) => {
                    if (member_view.model.get('is_disabled')) {
                        member_view.$el.hide();
                    } else {
                        matched_views.push(member_view);
                    }
                });

                break;
            case 'pending':
                _.each(this.views.invitation, (invitation_view) => {
                    matched_views.push(invitation_view);
                });

                _.each(this.views.workspace_member_preview, (member_view) => {
                    member_view.$el.hide();
                });
                break;
            case 'deactivated':
                _.each(this.views.invitation, (invitation_view) => {
                    invitation_view.$el.hide();
                });

                _.each(this.views.workspace_member_preview, (member_view) => {
                    if (member_view.model.get('is_disabled')) {
                        matched_views.push(member_view);
                    } else {
                        member_view.$el.hide();
                    }
                });

                break;
            default: // all
                _.each(this.views.invitation, (invitation_view) => {
                    matched_views.push(invitation_view);
                });

                _.each(this.views.workspace_member_preview, (member_view) => {
                    if (member_view.model.get('is_disabled')) {
                        member_view.$el.hide();
                    } else {
                        matched_views.push(member_view);
                    }
                });

                break;
        }

        matched_views.forEach((view) => {
            var model;

            if (view instanceof View_Workspace_Member_Preview) {
                model = Cache.user.get(view.model.get('user_id'));
            } else {
                model = view.model;
            }

            if (model) {
                if ((model.get('name') && model.get('name').toLowerCase().indexOf(this.search_value) !== -1) ||
                    (model.get('email') && model.get('email').toLowerCase().indexOf(this.search_value) !== -1)) {

                    view.$el.show();
                    show_count++;
                } else {
                    view.$el.hide();
                }
            } else {
                view.$el.hide();
            }
        });

        this.$el.find('.search-result-empty').toggle(!show_count);
    },

    render: function() {
        UI.setPageTitle('Members');

        var count_active  = Cache.workspace_member.where({is_disabled: false}).length;
        var count_pending = Cache.user_invitation.length;

        var seat_limit_reached = (count_active + count_pending) >= Cache.account.getUserMax();

        var content =
        '<main class="xlarge">' +
            '<div class="flex-between">' +
                '<h1 class="margin-bottom-0">Members</h1>' +
                (Cache.app.isAdmin() && !seat_limit_reached ?
                '<button type="button" class="primary medium inline invite-member"><i class="far fa-plus margin-right-8"></i>Invite</button>' : '') +
            '</div>' +

            '<div class="divider-32"></div>' +

            '<div class="tab">' +
                '<div class="tab-menu">' +
                '<div class="search-launcher"><input type="text" placeholder="Search members..."></div>' +
                    '<a href="#all">' +
                        '<span class="flex-c">' +
                            'All' +
                            '<span class="badge-secondary-invert badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + (count_active + count_pending) + '</span>' +
                        '</span>' +
                    '</a>' +
                    '<a href="#active">' +
                        '<span class="flex-c">' +
                            'Active<span class="badge-secondary-invert badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + count_active + '</span>' +
                        '</span>' +
                    '</a>' +
                    '<a href="#pending">' +
                        '<span class="flex-c">' +
                            'Pending<span class="badge-secondary-invert badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + count_pending + '</span>' +
                        '</span>' +
                    '</a>' +
                    '<a href="#deactivated">' +
                        '<span class="flex-c">Deactivated</span>' +
                    '</a>' +
                '</div>' +
            '</div>' +

            (seat_limit_reached ?
            '<div class="banner-warning banner-large margin-top-24 margin-bottom-12">You\'ve reached your seat limit. <a href="#" class="account-upgrade primary font-weight-medium">Upgrade your plan</a> to invite more team members.</div>' : '') +

            '<div class="region-members">' +
                '<div class="workspace-member-preview-header">' +
                    '<div></div>' +
                    '<div></div>' +
                    '<div></div>' +
                '</div>' +
                '<div class="search-result-empty search-result-empty-large">' +
                    '<span class="text-regular">No members found</span>' +
                '</div>' +
            '</div>' +
        '</main>';

        this.$el.html(content);

        this.$el.find('.tab-menu a[href="#' + this.member_type + '"]').addClass('active');

        _.each(this.views.workspace_member_preview, (view) => {
            view.render().$el.appendTo(this.$el.find('.region-members'));
        });

        _.each(this.views.invitation, (view) => {
            view.render().$el.appendTo(this.$el.find('.region-members'));
        });

        return this;
    }
});